(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'introPostgrad', {
            bindings: {
                content:    '<',
            },
            templateUrl: 'app/views/partials/content/intro-postgrad.html',
            controller:   IntroPostgradController,
            controllerAs: 'vm',

            renderingOptions: {
                'intro-postgrad': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    classes: [
                        'block-container',
                        'centraliser',
                        'two-col-layout',
                        'separated'
                    ]
                }
            }
        });


    /**
     * Renders a list of sub-qualifications within a postgraduate programme
     * or a list of postgraduates in postgraduate subjects.
     *
     * @param {ng.IScope} $scope
     * @param {SelectablesService} SelectablesService
     * @param {SubpagesService} SubpagesService
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function IntroPostgradController(
        $scope,
        SelectablesService,
        SubpagesService,
        LoggerFactory,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @const */
        var ITEMS               = SelectablesService.ITEMS,
        POSTGRADS_SELECTABLE_ID = 'postgradQuals',
        RESPONSE_ATTRIBUTE_PHD  = 'phd';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'PostgradSummaryCard' );




        /* ===== EXPOSE TO THE SCOPE ======================================== */


        /** @const */
        $scope.ITEMS                        = ITEMS;
        $scope.SELECTABLE_ATTRIBUTE_SUBJECT = CONFIG.PARAMS.SUBJECT;

        // Members
        $scope.Utils = Utils;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        // Methods
        vm.makeQueryObject = makeQueryObject;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function(){
            // Members
            vm.isPostgradSubpage        = SubpagesService.isPostgradSubpage();
            vm.isPostgradAreaSubpage    = SubpagesService.isPostgradAreaSubpage();
            vm.isSpecialisation         = SubpagesService.isSpecialisation();

            vm.qualificationTargetStateId = getQualsTargetStateId();

            initPhdItem();
            initSelectablesModelIfPostgradPage();
            initTexts();
        };


        /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
        Utils.addGenericPostLinkTrigger( vm );





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * @returns {uirouter.ParamsDefinition}
         */
        function makeQueryObject( stateParamValue ) {
            // Set URL fragments if on Postgraduate areas
            
            if ( vm.content.childFolderType === "specialisation")  {
                var stateParams = {};

                stateParams[ SubpagesService.getSelectableAttribute() ] = stateParamValue;
                vm.isSpecialisation = true;
               
                return stateParams;
            }
            
            if ( vm.isPostgradAreaSubpage ) return { '#': stateParamValue };

            // Pre-select sub-qualification if on Postgraduate programmesub-qualification if on Postgraduate programme
            if ( vm.isPostgradSubpage ) {
                
                var stateParams = {};

                stateParams[ SubpagesService.getSelectableAttribute() ] = stateParamValue;

                return stateParams;
            }

            logger.warn( "Cannot create a query/anchor with a pre-selected qualification or sub-qualification - Ignoring. Dynamic block `intro-postgrad` is probably used inside an unsupported page type." );

            return {};
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initTexts() {
            $scope._ = vm.isPostgradSubpage ? TEXTS.POSTGRAD.INTRO[ SubpagesService.getSelectableAttribute().toUpperCase() ] : TEXTS.POSTGRAD.INTRO.DEFAULT;

            $scope._.INTRO = TEXTS.POSTGRAD.INTRO;
        }


        /**
         * Initialises Controller-bound methods for PhD item rendering.
         */
        function initPhdItem() {
            vm.getStateIdFromTabId  = SubpagesService.getStateIdFromSectionId;
            vm.constructPhdAnchor   = Utils.anchorConstructorFactory( vm.content.hasOwnProperty( RESPONSE_ATTRIBUTE_PHD ) ? vm.content[ RESPONSE_ATTRIBUTE_PHD ] : vm, 'asset_contents', 'heading' );
        }


        /**
         * Constructs state ID required by `ui-sref` template directive.
         *
         * @returns {null|string}
         */
        function getQualsTargetStateId() {

            if ( vm.content.hasOwnProperty('childFolderType') && vm.content.childFolderType === "specialisation" ) { return CONFIG.STATES.SPECIALISATIONS.REQUIREMENTS; }

            if ( vm.isPostgradSubpage ) return CONFIG.STATES.POSTGRADS.REQUIREMENTS;


            if ( vm.isPostgradAreaSubpage ) return CONFIG.STATES.POSTGRAD_AREAS.QUALIFICATIONS;

            logger.error( "Cannot generate links within qualifications listing. Dynamic block `intro-postgrad` is probably used inside an unsupported page type" );

            return null;
        }


        function initSelectablesModelIfPostgradPage() {
            if ( vm.isPostgradSubpage ) {
                SelectablesService.getSelectablesByIdPromise( POSTGRADS_SELECTABLE_ID ).then( function ( selectables ) {
                    vm.selectablesModel = selectables.model;
                    vm.isModelReady = true; // Semaphor to sync selected qual with component's
                }).catch( function( err ) {
                    logger.error( err );
                });
            } else {
                vm.isModelReady = true; // Semaphor
            }
        }
    }



    IntroPostgradController.$inject = [ '$scope', 'SelectablesService', 'SubpagesService', 'LoggerFactory', 'Utils', 'TEXTS', 'CONFIG' ];
})();
